import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input, TemplateRef,
} from '@angular/core';
import { TooltipWidthDisabledDirective } from "@atlas-workspace/shared/directives";
import { TruncatePipeModule } from "@atlas-workspace/shared/pipes";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { PlacementArray } from "@ng-bootstrap/ng-bootstrap/util/positioning";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'atl-ellipsis-tooltip',
  template: `
    <div
      *ngIf="text"
      #wrap
      class="wrapper d-flex align-items-center min-w-0"
      [ngbTooltip]="tooltipTruncate ? (text | truncate: tooltipTruncate) : text"
      atlTooltipWidthDisabled
      [tooltipWidthDisabledOfElement]="ellipsisRef"
      [disableTooltipFn]="disableTooltipFn"
      [disableTooltip]="disableTooltip"
      [placement]="placementTooltip"
      [openDelay]="tooltipOpenDelay"
      triggers="hover touchstart"
      container="body"
    >
      <span
        #ellipsisRef
        class="ellipsis d-block pointer-events-none"
      >
        <ng-container *ngIf="isTemplate; else stringContent">
          <ng-container *ngTemplateOutlet="text"></ng-container>
        </ng-container>

        <ng-template #stringContent>
          {{ text }}
        </ng-template>
      </span>
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-content: center;
        min-width: 0;
      }

      .wrapper {
        font-size: inherit;
        line-height: inherit;
        font-weight: inherit;
        color: inherit;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule, TooltipWidthDisabledDirective, NgbTooltipModule, TruncatePipeModule],
})
export class EllipsisTextComponent {
  @Input() text!: string | TemplateRef<any>;
  @Input() disableTooltipFn?: () => boolean;
  @Input() disableTooltip = false;
  @Input() tooltipTruncate?: number;
  public readonly placementTooltip: PlacementArray = ['top', 'bottom', 'left', 'right'];
  public readonly tooltipOpenDelay = 400;

  get isTemplate(): boolean {
    return this.text instanceof TemplateRef;
  }
}
